import { useState, useEffect } from 'react';
import { Environment } from '../environment';

const API_BASE_URL = Environment.API_URL;

// Cache global de URLs
const urlCache = new Map<string, string>();

export const useImageUrl = (imageId: string | undefined): string => {
    const [url, setUrl] = useState<string>('');

    useEffect(() => {
        if (!imageId) {
            setUrl('');
            return;
        }

        // Se for URL completa, retorna direto
        if (imageId.startsWith('http')) {
            setUrl(imageId);
            return;
        }

        // Se não for ID do MongoDB (24 caracteres hex), assume que é o filename direto
        if (!/^[0-9a-fA-F]{24}$/.test(imageId)) {
            const directUrl = `${API_BASE_URL}/files/${imageId}`;
            setUrl(directUrl);
            return;
        }

        // Verifica cache
        if (urlCache.has(imageId)) {
            setUrl(urlCache.get(imageId)!);
            return;
        }

        // É um ID do MongoDB - precisa buscar o key via /pictures/:id
        const fetchImageKey = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/pictures/${imageId}`, {
                    headers: { 'x-api-key': Environment.API_KEY },
                });
                if (!response.ok) {
                    throw new Error('Imagem não encontrada');
                }
                const data = await response.json();
                
                // A API retorna { name, size, key, url, date }
                // Sempre construir a URL usando API_BASE_URL para garantir a porta correta
                const imageUrl = `${API_BASE_URL}/files/${data.key}`;
                urlCache.set(imageId, imageUrl);
                setUrl(imageUrl);
            } catch (_) {
                setUrl('');
            }
        };

        fetchImageKey();
    }, [imageId]);

    return url;
};
